<template>
  <div class="animated revealUp">
    
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">{{ $t('edit')}} Access Control</div>
      <router-link class="btn-blue" to="/access-control-list">Access Control List</router-link>
    </div>

    <div class="row mb-4">
      <div class="col-md-9 align-self-center">
        <p class="mb-0">
          Editing access for Role:
          <strong>{{ cRoleName}}</strong>
          <!-- <strong>atish@binarynumbers.io</strong> -->
        </p>
      </div>

      <!-- <div class="col-md-3">
        <div class="dropdown-curve-container">
          <label>{{ $t('select') }} Role</label>
          <b-dropdown variant="dropdown-curve" class="w-100">
            <b-dropdown-item>Administrator</b-dropdown-item>
          </b-dropdown>
        </div>
      </div>-->
    </div>

    <!-- <div class="white-wrapper">
      <table class="acl-table">
        <thead>
          <tr>
            <td>
              <strong>PERMISSION</strong>
            </td>
            <td>
              <strong>VIEW</strong>
            </td>
            
          </tr>
        </thead>
      
        <tbody v-for="(mod,moduleIndex) in modules" :key="moduleIndex">
          <tr>
            <td colspan="3">
              <span class="font-italic font-weight-bold border-bottom">{{mod.module_name }}</span>
            </td>
          </tr>
          <tr v-for="(mod1,moduleIndex1) in mod.modules" :key="moduleIndex1">
            <td>{{mod1.module_name}}</td>
            <td>
              <b-form-checkbox
                class="j-checkbox"
                v-model="mod1.view"
                value="Y"
                unchecked-value="N"
                @change="editEditPermission(mod1,1)"
              >&nbsp;</b-form-checkbox>
            </td>
           
          </tr>

          
        </tbody>

       
      </table>
 
    </div> -->
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import UserService from "@/services/UserService";

export default {
  data() {
    return {
      accessLevels: ["View application Information", true, false],
      modules: [],
      ro_id: "",
      cRoleName: ""
    };
  },
  mounted() {
   // this.getModuleList();
  },
  beforeMount() {
    const { role_id, role_name } = this.$route.query;
    this.ro_id = role_id;
    this.cRoleName = role_name;
    console.log("role_id :", role_id);
  },

  methods: {
    getModuleList: function() {
      let loader = this.$loading.show();
      let payload = {
        role_id: this.ro_id
      };
      // console.log("payload :", payload);
      UserService.ListAllModules(payload)
        .then(response => {
          loader.hide();
          const { data } = response;
          if (data.status) {
            this.modules = data.Records;
            // console.log("this.modules :", this.modules[0].modules[0].view);
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    // editViewPermission: function(mod, accessType) {
    //   console.log("mod :", mod);
    //   let payload = {
    //     role_id: this.ro_id,
    //     module_id: mod.module_id,
    //     access_id: accessType,
    //     is_active: mod.view
    //   };
    //   console.log("accessType :", accessType);
    //   console.log("payload :", payload);
    //   UserService.ViewPerma(payload)
    //     .then(response => {
    //       const { data } = response;
    //       if (data.status) {
    //         // this.modules = data.Records;
    //         // console.log("this.modules :", this.modules);
    //       } else {
    //         this.$toasted.show(data.message);
    //       }
    //     })
    //     .catch(this._CatchError);
    // },
    editEditPermission: function(mod, accessType) {
      console.log("modv :", mod);
      let payload = {
        role_id: this.ro_id,
        module_id: mod.module_id,
        access_id: accessType,
        mod
      };
      console.log("accessType :", accessType);
      console.log("payload :", payload);
      UserService.EditPerma(payload)
        .then(response => {
          const { data } = response;
          if (data.status) {
            this.$toasted.show("User Permission updated successfully");
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    }
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/Pages/AccessControlList/editAccessContol.vue